import React from "react";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./routes/AppRoutes";
import "./styles/global.css"

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Toaster position="top-right"
        toastOptions={{
          style: {
            zIndex: 99999,
          },
        }}
      />
      <AppRoutes />
    </AuthProvider>
  );
};

export default App;